import Button from '@/components/atoms/Button';
import { Skeleton } from '@/components/atoms/Skeleton';
import { Fragment } from 'react';
import { ListagemCategoriasProps } from '../..';
import * as S from './styles';
import Heading from '@/components/atoms/Heading';

export default function ListagemCategoriasDesktop(
  props: ListagemCategoriasProps,
) {
  const { $categorias, $categoriaSelecionada, $funcaoCliqueCategoria } = props;

  return (
    <S.Container>
      <Heading
        $priority={3}
        $size={4}
        $color="neutral"
        $weight="bold"
        $align="left"
        $highContrast={true}
        $text="Categorias"
      />
      {$categorias.length < 2 ? (
        <Fragment key="skeleton_categoria">
          <Skeleton
            key="skeleton_categoria_1"
            style={{ width: 160, height: 38 }}
          />
          <Skeleton
            key="skeleton_categoria_2"
            style={{ width: 160, height: 38 }}
          />
          <Skeleton
            key="skeleton_categoria_3"
            style={{ width: 160, height: 38 }}
          />
          <Skeleton
            key="skeleton_categoria_4"
            style={{ width: 160, height: 38 }}
          />
          <Skeleton
            key="skeleton_categoria_5"
            style={{ width: 160, height: 38 }}
          />
        </Fragment>
      ) : (
        $categorias.map((categoria, index) => (
          <Fragment key={categoria?.nome}>
            <Button
              $size={2}
              $variant="ghost"
              $active={index === $categoriaSelecionada}
              $disable={index === $categoriaSelecionada}
              $color="neutral"
              $highContrast={false}
              $loading={false}
              $focusRing={false}
              $text={categoria.nome}
              $onClick={() =>
                $funcaoCliqueCategoria({
                  categoria,
                  index,
                })
              }
            />
          </Fragment>
        ))
      )}
    </S.Container>
  );
}
